import HideCategorySelector from "@components/plasmic/custom-options/category-selector/hide-category-selector";
import SingleCategorySelector from "@components/plasmic/custom-options/category-selector/single-category-selector";

import CECategorySelector from "@stadium/shared/src/components/plasmic/custom-options/category-selector/ce-category-selector";
import { CE_05_SliceProps } from "@components/swagmagic/dynamic/slices/brand-carousel/plasmic-props";
import { CE_09_SliceProps } from "@components/swagmagic/dynamic/slices/catalog-entries-grid/plasmic-props";

import {
  CATALOG_ENTRIES_VARIANT,
  CE_01,
  CE_05,
  CE_12,
  CUSTOM,
  DEFAULT,
  GRID_VARIANT,
} from "@helpers/plasmic/slices";

import {
  URL_TYPE_OPTIONS,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  CATEGORY_HOME_LINK_TYPE,
  OTHER_LINK_TYPE,
  FILTER_OPTIONS,
} from "@stadium/shared/src/constants/stores/routes";

export const CatalogEntriesPlasmicProps = {
  className: {
    type: "string",
    defaultValue: "",
  },
  variant: {
    type: "choice",
    options: CATALOG_ENTRIES_VARIANT,
    defaultValue: CE_01,
  },
  viewType: {
    type: "choice",
    options: [DEFAULT, CUSTOM],
    defaultValue: DEFAULT,
    forceRemount: true,
  },
  title: {
    type: "string",
    description: "The title will be visible when a value is provided.",
  },
  description: {
    type: "string",
    description: "The description will be visible when a value is provided.",
  },
  btnText: {
    type: "string",
    hidden: (props) => GRID_VARIANT.includes(props.variant),
    description: "The button text will be visible when a value is provided.",
  },
  btnLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATEGORY_HOME_LINK_TYPE,
    hidden: (props) => GRID_VARIANT.includes(props.variant),
  },
  btnLinkOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      GRID_VARIANT.includes(props.variant) || props.btnLinkType !== OTHER_LINK_TYPE,
  },
  btnLinkCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      GRID_VARIANT.includes(props.variant) ||
      (props.btnLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.btnLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  categorySlug: {
    type: "custom",
    control: CECategorySelector,
    description: "Selected category will be treated as the root category for the catalog entries",
  },
  linkToNewTab: {
    type: "boolean",
    defaultValue: false,
    hidden: (props) => GRID_VARIANT.includes(props.variant),
  },
  showSubcategories: {
    type: "boolean",
    defaultValue: false,
    description:
      "Include subcategories too along with the parent categories in the catalog entries",
    helpText:
      "By Default, only parent categories are shown. If you want to show subcategories too, enable this option.",
    hidden: (props) => props.viewType === CUSTOM && props.variant !== CE_05,
  },
  visibleCategoryCount: {
    type: "number",
    description: "Number of categories to show in the catalog entries",
    hidden: (props) => props.viewType === CUSTOM && props.variant !== CE_05,
  },
  ...CE_05_SliceProps,
  hideCategories: {
    type: "custom",
    control: HideCategorySelector,
    description: "Categories to hide from the catalog entries",
    defaultValue: [],
    hidden: (props) => props.viewType === CUSTOM && props.variant !== CE_05,
  },
  orderCategories: {
    type: "choice",
    defaultValue: [],
    description: "Categories to order in the catalog entries",
    options: (_, contextData) => contextData?.renderedSlugs,
    multiSelect: true,
    hidden: (props) => props.viewType === CUSTOM && props.variant !== CE_05,
  },
  ...CE_09_SliceProps,
  topLevelCategories: {
    type: "array",
    description: "Categories to display in the catalog entries.",
    hidden: (props) => props.viewType === DEFAULT || props.variant !== CE_12,
    itemType: {
      type: "object",
      nameFunc: (item) => item?.name || "Category",
      fields: {
        name: {
          type: "string",
        },
        code: {
          type: "custom",
          control: SingleCategorySelector,
          helpText: "Select a category to display in the catalog entries.",
          defaultValue: "",
        },
      },
    },
  },
  customCategories: {
    type: "array",
    description: "Categories to display in the catalog entries.",
    hidden: (props) => props.viewType === DEFAULT || props.variant === CE_05,
    itemType: {
      type: "object",
      nameFunc: (item) => item?.name || "Category",
      fields: {
        portraitImage: {
          type: "imageUrl",
        },
        imageMobile: {
          type: "imageUrl",
          helpText:
            "Optional. Image shown on mobile (≤ 767px). Falls back to portraitImage if unset.",
        },
        imageTablet: {
          type: "imageUrl",
          helpText:
            "Optional. Image shown on tablet (768px–991px). Falls back to portraitImage if unset.",
        },
        name: {
          type: "string",
        },
        urlType: {
          type: "choice",
          options: URL_TYPE_OPTIONS,
          defaultValue: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
        },
        filterOptions: {
          type: "choice",
          options: FILTER_OPTIONS,
        },
        otherUrl: {
          type: "string",
          helpText: "Need to select 'urlType' as 'Other' to make this url work.",
        },
        linkToNewTab: {
          type: "boolean",
          defaultValue: false,
        },
        code: {
          type: "custom",
          control: SingleCategorySelector,
          helpText: "Select a category to display in the catalog entries.",
          defaultValue: "",
        },
        description: {
          type: "string",
          description: "This will be shown as the description for the CE-03 and CE-04 variant.",
        },
        btnText: {
          type: "string",
          description: "This will be shown as the description for the CE-03 and CE-04 variant.",
        },
      },
    },
  },
};
